import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../Navbar";
import NavbarHB from "../NavbarHB";
import Headeraccount from "../Headeraccount";
import moment from "moment";
import Footer from "../Footer";
import { Button, Checkbox, IconChevronLeft, IconChevronRight, Select, Table, TextBox, ThemeProvider, ProgressIndicator } from '@veneer/core';
import EncodingService from "../api/encoding/EncodingService";
import { cloneDeep, isEmpty } from 'lodash';
import { Modal } from "react-bootstrap";
import { AuthContext } from "../auth/AuthContext";
import InlineEdit from "../components/InlineEdit";
import { showToast } from "../components/Toast";
import { sortedBusinessOptions } from "../components/Sort";
import encodingService from "../api/encoding/EncodingService";
import { useDownloadHandler } from "../components/DownloadHandler";
import LoadingBar from "../components/LoadingBar";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";

const Monthlyprice = (props) => {

    const inputRef1 = useRef();
    const inputRef2 = useRef();

    const [date, setDate] = useState(new Date())
    const [current, setCurrent] = useState(moment(date).format("MMMM YYYY"));
    const [counter, setCounter] = useState(0);
    const [prev1, setPrev1] = useState("black");
    const [next1, setNext1] = useState("black");
    const [cursor11, setCursor11] = useState("pointer");
    const [currBold, setCurrBold] = useState("f-w");
    const [adjustment, setAdjustment] = useState(0);
    const [usageList, setUsageList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [businessOption, setBusinessOption] = useState([]);
    const [selectedBusiness, setSelectedBusiness] = useState({});
    const [reportMonth, setReportMonth] = useState('');
    const [reportYear, setReportYear] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [createDate, setCreateDate] = useState('');
    const [prevDisabled, setPrevDisabled] = useState(false);
    const [nextDisabled, setNextDisabled] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [currentAndFuture, setCurrentAndFuture] = useState(false);
    const [futureQuarter, setFutureQuarter] = useState(false);
    const [currentAndFutureQuarter, setCurrentAndFutureQuarter] = useState(false);
    const [adjustments, setAdjustments] = useState([]);
    const [adj, setAdj] = useState("");
    const [memo, setMemo] = useState('');
    const [errorAdj, setErrorAdj] = useState(false);
    const [errorMemo, setErrorMemo] = useState(false);
    const [addAdjust, setAddAdjust] = useState(0);
    const [adjEnabled, setAdjEnabled] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [memoErrorMessage, setMemoErrorMessage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loader, setLoader] = useState(false);
    const [analyticsLoading, setAnalyticsLoading] = useState(false);
    const [usageLoading, setUsageLoading] = useState(false);

    const downloadUsageHandler = useDownloadHandler(encodingService.downloadUsage, setUsageLoading);
    const downloadAnalyticsHandler = useDownloadHandler(encodingService.downloadAnalytics, setAnalyticsLoading);
    const { uiAccess } = useContext(AuthContext);
    const { role } = useContext(AuthContext);
    const inlineEditEnabledOnlyForFutureQuarter = uiAccess?.enabledOnlyForFutureQuarter && !futureQuarter;

    useEffect(() => {
        EncodingService.getAllAccount().then((res) => {
            let arr = []
            res?.data?.forEach(element => {
                if (element.businessName !== 'SPS') { arr.push(element) }
            });
            if (!isEmpty(arr)) {
                setBusinessOption(arr);
                setSelectedBusiness({ id: arr[0].id, businessName: arr[0].businessName });
                setCreateDate(arr[0].createDate);
                setCurrentAndFuture(true);
                setFutureQuarter(false);
                setCurrentAndFutureQuarter(true);
                setMonthlyData(moment().month(), moment().year(), arr[0].id);
            }
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }, [])

    const setMonthlyData = (month, year, businessId) => {
        setReportMonth(month + 1);
        setReportYear(year);
        EncodingService.getSPSMonthlyData(month + 1, year, businessId).then((res) => {
            const usage = res?.data?.usage.map((e, index) => {
                return {
                    uid: index,
                    ...e
                }
            })
            setAdjustment(res?.data?.adjustmentDescription);
            setUsageList(cloneDeep(usage));
            setOriginalList(cloneDeep(usage));
            setLoading(false);
            setTableData(usage);
            setAdjustments(res?.data?.adjustments);

            let listDataTable = [];

            usageList.forEach((item) => {
                let obj = {
                    encodedSupplyDescription: <div className="encodedesc">{item.encodedSupplyDescription}</div>,
                    priceDescription: <div className="totaldesc1"><span>&#36;</span> {item.priceDescription}</div>,
                    cap: <div className="totaldesc1"> {item.cap}</div>,
                    used: <div className="totaldesc1"> {item.used}</div>,
                    totalDescription: <div className="totaldesc"><span>&#36;</span> {item.totalDescription}  </div>,
                }
                listDataTable.push(obj)
            });
            setUsageList(listDataTable);
        });
    };

    const getPriceAndCapDetails = () => {
        setMonthlyDataForInlineEdit(moment(date).month(), moment(date).year(), selectedBusiness.id)
    }

    const setMonthlyDataForInlineEdit = (month, year, businessId) => {
        setReportMonth(month + 1);
        setReportYear(year);
        EncodingService.getSPSMonthlyData(month + 1, year, businessId).then((res) => {
            const usage = res?.data?.usage.map((e, index) => {
                return {
                    uid: index, ...e
                }
            })
            setTableData(usage)
        })
    }

    const onChange = async (data) => {
        let value = data.value;
        let businessData = { id: data.value, businessName: data.label };
        const isSameBusiness = JSON.stringify(businessData) === JSON.stringify(selectedBusiness);
        if (!isSameBusiness) {
            setLoading(true);
            setSelectedBusiness(businessData);
            setError('');
            setDate(new Date());
            businessOption.forEach(e => {
                if (e.id === Number(value)) {
                    const date = new Date();
                    setCreateDate(e.createDate);
                    setCurrent(moment(date).format("MMMM YYYY"));
                    setCounter(0);
                    setCurrentAndFuture(moment(date).isSameOrAfter(new Date(), "month"));
                    setFutureQuarter(isFutureQuarter(moment(date)));
                    setCurrentAndFutureQuarter(isCurrentAndFutureQ(moment(date)));
                    setCurrBold("f-w");
                    setNext1("black");
                    setPrev1(moment(date).format("MMMM YYYY") === moment(e.createDate).format("MMMM YYYY") ? "grey" : "black");
                    setPrevDisabled(moment(date).format("MMMM YYYY") === moment(e.createDate).format("MMMM YYYY"));
                    setNextDisabled(false);
                    setMonthlyData(moment().month(), moment().year(), value);
                }
            });
        }
    }

    const linkClicked = () => {
        setError('')
    }

    const selectRow = (dataArray, checked, id) => {
        const updatedDataArray = [...dataArray];
        const index = updatedDataArray.findIndex((row) => row.uid === id);
        updatedDataArray[index].enableSupply = checked;
        return updatedDataArray;
    }

    const handleSelect = (event, index) => {
        saveChanges(selectRow(tableData, event.target.checked, index))
        setTableData(selectRow(tableData, event.target.checked, index));
    }

    const handleInputChange = (name, value, index) => {
        setTableData(tableData.map((x, key) => (key === index ? { ...x, [name]: value } : x)))
    }

    const handleAdjChange = (setName, value) => {
        setName(value)
        setErrorMemo(false)
        setErrorAdj(false)
    }

    const detailsAdjustment = () => {
        setIsOpen(true)
    }

    const hideModal = () => {
        setIsOpen(false);
        setAdj('');
        setMemo('');
        setErrorMemo(false);
        setErrorAdj(false);
    };

    const validateChanges = () => {
        let valid = true;
        let errorMessage = '';
        for (const e of tableData) {
            if (!valid) {
                break;
            }
            else if (e.priceDescription === "" || e.priceDescription === undefined) {
                valid = false;
                errorMessage = 'Price can not be empty';
                getPriceAndCapDetails();
            }
            else if (e.cap === "" || e.cap === undefined) {
                valid = false;
                errorMessage = 'Cap can not be empty';
                getPriceAndCapDetails();
            }
            else if (Number(e.priceDescription) < 0.00 || Number(e.priceDescription) > 99.99) {
                valid = false;
                errorMessage = 'Price can not be less than 0.00 and greater than 99.99';
                getPriceAndCapDetails()
            }
            else if (Number(e.cap) < 0 || Number(e.cap) > 10000) {
                valid = false;
                errorMessage = 'Cap can not be less than 0 and greater than 10000';
                getPriceAndCapDetails()
            }
            else if (!isNaN(Number(e.cap)) && (e.cap).toString().indexOf('.') !== -1) {
                valid = false;
                errorMessage = 'Cap can not be a fraction';
                getPriceAndCapDetails()
            }
        }
        setError(errorMessage);
        return valid;
    }

    const saveChanges = async (data = []) => {

        setError('');
        if (validateChanges()) {
            setLoader(true)
            data = data.length ? data : tableData;

            for (const e of data) {
                const actualData = originalList.filter((element) => element.uid === e.uid);

                if (JSON.stringify(actualData[0]) !== JSON.stringify(e)) {
                    const requestData = {
                        ...e,
                        year: reportYear,
                        month: reportMonth,
                        businessId: selectedBusiness.id,
                        adjustment: adjustment,
                    };

                    try {
                        const res = await EncodingService.updateSupplies(requestData);
                        showToast(<p>Supply data updated successfully for <b>{e.encodedSupplyDescription}</b></p>, 'success')
                        setLoader(false)
                        const usage = res?.data?.usage.map((item, index) => ({
                            uid: index,
                            ...item,
                        }));

                        setAdjustment(res?.data?.adjustmentDescription);
                        setUsageList(cloneDeep(usage));
                        setOriginalList(cloneDeep(usage));
                        setLoading(false);
                        setTableData(usage);
                        setAdjustments(res?.data?.adjustments);
                    } catch (error) {
                        setLoader(false)
                        console.error('Error updating supplies:', error);
                    }
                }
            }
        } else {
            return;
        }
        setLoader(false)
        getPriceAndCapDetails();
    }

    const updateAdjustment = () => {
        let error;
        if (!isEmpty(adj) && adj >= -1000 && adj <= 1000) {
            setErrorAdj(false)
            error = false;
        }
        else {
            setErrorAdj(true)
            error = true;
        }
        if (memo.trim().length === 0 || isEmpty(memo)) {
            setErrorMemo(true)
            setMemoErrorMessage("Memo cannot be empty")
            error = true;
        }
        else {
            setErrorMemo(false)
            setMemoErrorMessage('')
        }
        if (error) {
            setAddAdjust(0)
            return
        }
        let adj1 = parseFloat(adj).toFixed(2);
        if (addAdjust === 0 && !error) {
            setAddAdjust(1)
            setBtnLoading(true)
            const data = {
                year: reportYear,
                month: reportMonth,
                businessId: selectedBusiness.id,
                adjustment: adj1,
                memo: memo
            }
            EncodingService.updateAdjustment(data).then((res) => {
                showToast(<p>Update successful for adjustment <span><b>{res?.data?.adjustmentDescription}</b></span></p>, 'success')
                setAdjustment(res?.data?.adjustmentDescription);
                setAdjustments(res?.data?.adjustments);
                setAddAdjust(0);
                setBtnLoading(false);
            });
        }
        setMemo('')
        setAdj('')
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value)
    }

    const prev = () => {
        setLoading(true);
        setCurrentPage(1);
        setPageSize(10);
        setNext1('black');
        setNextDisabled(false);
        setCursor11('pointer');
        setError('');
        const prevDate = moment(date).add(-1, "months");
        if (moment(createDate).format("MMMM YYYY") !== moment(date).format("MMMM YYYY")) {
            let c = counter;
            c--;
            setCounter(c);
            setPrev1('black');
            setPrevDisabled(false);
            setCurrentAndFuture(prevDate.isSameOrAfter(new Date(), 'month'));
            setFutureQuarter(isFutureQuarter(prevDate));
            setCurrentAndFutureQuarter(isCurrentAndFutureQ(prevDate));
            setCursor11('pointer');
            const isCurrentOrPreviousMonth = role === 'SPTS Administrator'
                ? moment(prevDate).isSameOrAfter(moment().subtract(1, 'months'), 'month')
                : moment(prevDate).isSameOrAfter(moment(), 'month');
            setAdjEnabled(isCurrentOrPreviousMonth);
            console.log(`Prev Function - Counter: ${c}, adjEnabled: ${isCurrentOrPreviousMonth}`);
            if (moment(createDate).format("MMMM YYYY") === moment(prevDate).format("MMMM YYYY")) {
                setPrevDisabled(true);
                setPrev1('grey');
                setCursor11('default');
            } else {
                setPrev1('black');
                setPrevDisabled(false);
                setCursor11('pointer');
            }
            setCurrent(moment(prevDate).format("MMMM YYYY"));
            if (moment(prevDate).format("MMMM YYYY") === c) {
                setCurrBold("f-w");
            } else {
                setCurrBold("");
            }
        }
        if (moment(new Date()).format("MMMM YYYY") === moment(prevDate).format("MMMM YYYY")) {
            setCurrBold("f-w");
        } else {
            setCurrBold("");
        }
        setMonthlyData(moment(prevDate).month(), moment(prevDate).year(), selectedBusiness.id);
        setDate(prevDate);
    };

    const next = () => {
        setLoading(true);
        setCurrentPage(1);
        setPageSize(10);
        setPrev1('black');
        setPrevDisabled(false);
        setCursor11('pointer');
        setError('');
        const dateNext = moment(date).add(1, "months");

        if (counter < 6) {
            let c = counter;
            c++;
            setCounter(c);
            setCurrent(moment(dateNext).format("MMMM YYYY"));
            setCurrentAndFuture(dateNext.isSameOrAfter(new Date(), "month"));
            setFutureQuarter(isFutureQuarter(dateNext));
            setCurrentAndFutureQuarter(isCurrentAndFutureQ(dateNext));
            const isCurrentOrPreviousMonth = role === 'SPTS Administrator'
                ? moment(dateNext).isSameOrAfter(moment().subtract(1, 'months'), 'month')
                : moment(dateNext).isSameOrAfter(moment(), 'month');
            setAdjEnabled(isCurrentOrPreviousMonth);
            console.log(`Next Function - Counter: ${c}, adjEnabled: ${isCurrentOrPreviousMonth}`);
            if (c === 6) {
                setNext1('grey');
                setNextDisabled(true);
                setCursor11('default');
            } else {
                setNext1('black');
                setNextDisabled(false);
                setCursor11('pointer');
            }
        }
        if (moment(new Date()).format("MMMM YYYY") === moment(dateNext).format("MMMM YYYY")) {
            setCurrBold("f-w");
        } else {
            setCurrBold("");
        }
        setMonthlyData(moment(dateNext).month(), moment(dateNext).year(), selectedBusiness.id);
        setDate(dateNext);
    };

    const present = () => {
        setLoading(true);
        const date = new Date();
        setCurrent(moment(date).format("MMMM YYYY"));
        setCounter(0);
        setCurrentAndFuture(moment(date).isSameOrAfter(new Date(), "month"));
        setFutureQuarter(isFutureQuarter(moment(date)));
        setCurrentAndFutureQuarter(isCurrentAndFutureQ(moment(date)));
        setAdjEnabled(true);
        setCurrBold('f-w');
        setNext1('black');
        setPrev1(moment(date).format("MMMM YYYY") === moment(createDate).format("MMMM YYYY") ? 'grey' : 'black');
        setPrevDisabled(moment(date).format("MMMM YYYY") === moment(createDate).format("MMMM YYYY"));
        setNextDisabled(false);
        setError('');
        setMonthlyData(moment(date).month(), moment(date).year(), selectedBusiness.id);
        setDate(date)
    }

    const isFutureQuarter = (date) => {
        if (moment().year() < date.year()) {
            return true;
        }
        else if (moment().year() === date.year()) {
            if (moment().quarter() < date.quarter()) {
                return true;
            }
        }
        return false;
    }

    const isCurrentAndFutureQ = (date) => {
        if (moment().year() < date.year()) {
            return true;
        }
        else if (moment().year() === date.year()) {
            if (moment().quarter() <= date.quarter()) {
                return true;
            }
        }
        return false;
    }



    return (
        <>
            {loader && (
                <div className="loader-overlay">
                    <ProgressIndicator
                        appearance="circular"
                        behavior="indeterminate"
                    />
                </div>
            )}
            <div>
                <Headeraccount />
                {uiAccess?.navbarHB && <NavbarHB role={props.role} />}
                {uiAccess?.navbarSPS && <Navbar role={props.role} />}
                <div className="tableWrapper">
                    <div>
                        <div className="col-md-3 p-l-0 font-hp p-b-20 p-t-5">
                            <h6 className="subtitle-medium">Current Account</h6>
                            <div id="currentAccount">
                                <ThemeProvider mode="light" shape="round" density="high">
                                    <Select
                                        clearIcon={false}
                                        value={[selectedBusiness.businessName]}
                                        placeholder={selectedBusiness.businessName}
                                        options={sortedBusinessOptions(businessOption, 'sortMonthlyPrice')}
                                        onChange={(e) => onChange(e)}
                                        id="account"
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tableWrapper">
                    <div className={'monthlySummary'}>
                        <div className="mainHead p-80 ">
                            <div>
                                <h5 className="subtitle-large">Monthly summary</h5>
                            </div>
                        </div>
                        <div className="currentMonth">
                            <div className="font-hp p-b-20 monthly">
                                <div id={'monthsNavigation'}>
                                    <div className="font-hp current-month-mp">
                                        <span role="link" onClick={present} id="currentMonthsummary">
                                            Current month
                                        </span>
                                    </div>
                                    <div className={'monthDetails'}>
                                        <div
                                            role="link"
                                            style={{ color: prev1, cursor: cursor11 }}
                                            onClick={() => prevDisabled === false && prev()}
                                            id="spsprev"
                                            className="prev"
                                        >
                                            Previous month
                                        </div>
                                        <IconChevronLeft />
                                        <div id="p-c" className={currBold}>
                                            {current}
                                        </div>
                                        <IconChevronRight />
                                        <div
                                            role="link"
                                            id="spsnext"
                                            style={{ color: next1, cursor: cursor11 }}
                                            onClick={() => nextDisabled === false && next()}
                                        >
                                            Next month
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div>
                                <Table
                                    columnResize
                                    loading={loading}
                                    id="monthlyprice"
                                    className={'monthlyprice'}
                                    columns={[
                                        {
                                            id: "check",
                                            label: " ",
                                            sortable: false,
                                        },
                                        {
                                            id: "supply",
                                            label: "Encoded Supply",
                                            sortable: false,
                                        },
                                        {
                                            id: "priceDescription",
                                            label: <div style={{ width: "100%", textAlign: "right" }}>Price (US$)</div>,
                                            sortable: false,
                                        },
                                        {
                                            id: "cap",
                                            label: <div style={{ width: "100%", textAlign: "right" }}>Cap</div>, 
                                            sortable: false,
                                        },
                                        {
                                            id: "used",
                                            label: <div style={{ width: "100%", textAlign: "right" }}>Used</div>, 
                                            sortable: false,
                                        },
                                        {
                                            id: "totalDescription",
                                            label: <div style={{ width: "100%", textAlign: "right" }}>Usage total* (US$)</div>,
                                            sortable: false,
                                        },
                                        {
                                            id: "uid",
                                            label: "Id",
                                            index: "hidden",
                                        },
                                    ]}
                                    data={
                                        tableData ? tableData.slice((currentPage - 1) * pageSize,
                                            (currentPage - 1) * pageSize + pageSize).map((data, i) => {
                                                return {
                                                    check: (
                                                        <ThemeProvider
                                                            mode="light"
                                                            shape="round"
                                                            density="high"
                                                            id="cap"
                                                        >
                                                            <Checkbox
                                                                id={`check-box-${i}`}
                                                                name="check"
                                                                onChange={(event) =>
                                                                    handleSelect(event, ((currentPage - 1) * pageSize + i))
                                                                }
                                                                checked={data.enableSupply}
                                                                disabled={
                                                                    !(
                                                                        (uiAccess?.checkBoxEditPermission && !inlineEditEnabledOnlyForFutureQuarter &&
                                                                            currentAndFuture &&
                                                                            currentAndFutureQuarter) ||
                                                                        (uiAccess?.checkBoxEditPermission && !inlineEditEnabledOnlyForFutureQuarter &&
                                                                            futureQuarter)
                                                                    )
                                                                }
                                                            />
                                                        </ThemeProvider>
                                                    ),
                                                    supply: data.encodedSupplyDescription,
                                                    priceDescription:
                                                        (uiAccess?.priceEditPermission && !inlineEditEnabledOnlyForFutureQuarter &&
                                                            currentAndFuture &&
                                                            currentAndFutureQuarter) ||
                                                            (uiAccess?.priceEditPermission && !inlineEditEnabledOnlyForFutureQuarter &&
                                                                futureQuarter) ? (
                                                            <InlineEdit
                                                                text={data.priceDescription}
                                                                placeholder={data.priceDescription}
                                                                type="input"
                                                                childRef={inputRef1}
                                                                msg={error}
                                                                isAlignRight={true}
                                                            >
                                                                <TextBox
                                                                    ref={inputRef1}
                                                                    style={{
                                                                        textAlign: "right",
                                                                        width: "100%",
                                                                        display: "block",
                                                                    }}
                                                                    density="High"
                                                                    name="priceDescription"
                                                                    onChange={(e) => handleInputChange("priceDescription", e, ((currentPage - 1) * pageSize + i))}
                                                                    onBlur={() => saveChanges()}
                                                                    value={data.priceDescription}
                                                                    min={0}
                                                                    maxLength={99.99}
                                                                    placeholder=""
                                                                />
                                                            </InlineEdit>
                                                        ) : (
                                                            <span
                                                                className="f-r"
                                                                style={{
                                                                    textAlign: "right",
                                                                    width: "100%",
                                                                    display: "block",
                                                                }}>
                                                                {data.priceDescription}
                                                            </span>
                                                        ),
                                                    cap:
                                                        uiAccess?.capEditPermission && !inlineEditEnabledOnlyForFutureQuarter &&
                                                            currentAndFuture ? (
                                                            <InlineEdit
                                                                text={data.cap}
                                                                placeholder={data.cap}
                                                                type="input"
                                                                childRef={inputRef2}
                                                                msg={error}
                                                                isAlignRight={true}
                                                            >
                                                                <TextBox
                                                                    ref={inputRef2}
                                                                    style={{
                                                                        textAlign: "right",
                                                                        width: "100%",
                                                                        display: "block",
                                                                    }}
                                                                    density="High"
                                                                    name="cap"
                                                                    onChange={(e) => handleInputChange("cap", e, ((currentPage - 1) * pageSize + i))}
                                                                    onBlur={() => saveChanges()}
                                                                    value={data.cap}
                                                                    min={0}
                                                                    maxLength={10000}
                                                                    placeholder=""
                                                                />
                                                            </InlineEdit>
                                                        ) : (
                                                            <span
                                                                className="f-r"
                                                                style={{
                                                                    textAlign: "right",
                                                                    width: "100%",
                                                                    display: "block",
                                                                }}>
                                                                {data.cap}
                                                            </span>
                                                        ),

                                                    used: <div className="month-used" style={{ textAlign: 'right' }}>{data.used}</div>,
                                                    totalDescription: (
                                                        <div className="monthtotaldesc" style={{ textAlign: 'right' }}>
                                                            {typeof data.totalDescription === 'string'
                                                                ? data.totalDescription
                                                                : typeof data.totalDescription === 'number'
                                                                    ? data.totalDescription.toFixed(2)
                                                                    : null}
                                                        </div>
                                                    ),
                                                };
                                            })
                                            : []
                                    }
                                    preferences={{
                                        sortBy: {
                                            id: "encodedSupplyDescription",
                                            type: "ascending",
                                        }
                                    }}
                                    pagination={{
                                        currentPage: currentPage,
                                        pageSizeOptions: tableData.length <= 2 ? [{ value: tableData.length }] :
                                            tableData.length < 5 ? [{ value: 2 }, { value: tableData.length }] :
                                                tableData.length <= 8 ? [{ value: 2 }, { value: 4 }, { value: tableData.length }] :
                                                    tableData.length <= 9 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: tableData.length }] :
                                                        tableData.length <= 10 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: tableData.length }] : [{ value: 2 }, { value: 4 }, { value: 8 }, { value: 10 }, { value: tableData.length }],
                                        onPageChange: handlePageChange,
                                        onPageSizeChange: handlePageSizeChange,
                                        totalItems: tableData.length,
                                        pageSize: pageSize
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <br />
                        <div className="currentAdjustments">
                            <div>
                                <span className="font-hp m-r-10">Current Adjustment (US$)</span>
                            </div>
                            <div>
                                <span className="font-hp p-m-30  b-b-10">
                                    {adjustment + " "}
                                </span>
                            </div>
                            <div>
                                <Button
                                    id={"detailsBtn"}
                                    small={false}
                                    className="button-p"
                                    onClick={detailsAdjustment}
                                >
                                    Details
                                </Button>
                            </div>



                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-11 p-l-25">
                            <div className="b-b"></div>
                            <div className="font-hp">
                                *Tax/VAT and other adjustments not included
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-9">
                            <span className="c-b-f f-r" id="AccountdownloadAnalytics">
                                <a
                                    className={`a-link ${analyticsLoading ? 'loading' : ''}`}
                                    style={{ color: '#024ad8' }}
                                    onClick={(e) => downloadAnalyticsHandler(e, [reportYear, reportMonth, selectedBusiness.id])}
                                    href={"#"}
                                >
                                    {analyticsLoading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i> Downloading...
                                        </>
                                    ) : (
                                        "Download Analytics"
                                    )}
                                </a>
                                {analyticsLoading && <LoadingBar />}
                            </span>
                        </div>
                        <div className="col-2 ">
                            <span className="c-b-f f-r" id="AccountdownloadUsage">
                                <a
                                    className={`a-link ${usageLoading ? 'loading' : ''}`}
                                    href={`${process.env.REACT_APP_PUBLIC_URL}/v1/export/excel/${reportYear}/${reportMonth}/${selectedBusiness.id}`}
                                    style={{ color: '#024ad8' }}
                                    onClick={(e) => downloadUsageHandler(e, [reportYear, reportMonth, selectedBusiness.id])}
                                >
                                    {usageLoading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i> Downloading...
                                        </>
                                    ) : (
                                        "Download Usage"
                                    )}
                                </a>
                                {usageLoading && <LoadingBar />}
                            </span>
                        </div>
                    </div>
                </div>
                <Footer />
                <Modal
                    animation={false}
                    show={isOpen}
                    onHide={hideModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <Modal.Body>
                        <Table id="adjuster"
                            columns={[
                                {
                                    id: "adjusterDescription",
                                    label: "ADJUSTER",
                                },
                                {
                                    id: "dateDescription",
                                    label: "DATE",
                                },
                                {
                                    id: "amountDescription",
                                    label: <div style={{ width: "100%", textAlign: "right" }}>AMOUNT US$</div>,
                                },
                                {
                                    id: "memoDescription",
                                    label: "MEMO",
                                },
                            ]}
                            data={adjustments
                                ? adjustments.map((data) => {
                                    return {
                                        adjusterDescription: <div className="adjdesc">{data.adjusterDescription}</div>,
                                        dateDescription: <div className="datedesc" >{data.dateDescription}</div>,
                                        amountDescription: <div className="amtdesc" style={{ width: "100%" }}>{data.amountDescription}</div>,
                                        memoDescription: <div className="memodesc">{data.memoDescription}</div>

                                    };

                                })
                                : []
                            }
                        />
                        <br /> <br />
                        <div className="b-b"></div>
                        <br />
                        {uiAccess?.showAdjustmentSection && adjEnabled &&
                            <div>
                                <h5 className="subtitle-large">Add an adjustment</h5>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-4 p-0">
                                            <ThemeProvider mode="light" shape="round" density="high">
                                                <TextBox
                                                    className="amount"
                                                    id="adj"
                                                    name="adj"
                                                    label="Amount"
                                                    helperText="Range between -1000 to 1000"
                                                    value={adj}
                                                    onChange={(e) =>
                                                        handleAdjChange(setAdj, e)
                                                    }
                                                    error={errorAdj}
                                                    
                                                />
                                            </ThemeProvider>
                                        </div>
                                        <div className="col-md-5 p-0-0">
                                            <ThemeProvider mode="light" shape="round" density="high">
                                                <TextBox
                                                    id="memo"
                                                    className="memo"
                                                    name="memo"
                                                    label="Memo"
                                                    value={memo}
                                                    onChange={(e) =>
                                                        handleAdjChange(setMemo, e)
                                                    }
                                                    error={errorMemo}
                                                    helperText={errorMemo ? memoErrorMessage : ''}
                                                />
                                            </ThemeProvider>
                                        </div>
                                         <div className="row mt-3">
                                        <div className="col-md-2 m-t-2 p-0-0">
                                            <Button
                                                id={"saveBtn"}
                                                loading={btnLoading}
                                                small={false}
                                                className="button-p"
                                                onClick={updateAdjustment}
                                                style={{ width: "100%" }}>
                                                Save
                                            </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <br />
                        <br />
                        <div className="row justify-content-center">
                            <ThemeProvider mode="light" shape="round" density="high">
                                <Button
                                    id={"closeBtn"}
                                    appearance="secondary"
                                    small={false}
                                    onClick={hideModal}
                                >
                                    Close
                                </Button>
                            </ThemeProvider>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default Monthlyprice;